import { useEffect, useRef, type ReactNode } from 'react';
import styles from './commun.module.css';

export interface ProprietesEnTetePage {
  titre: string;
  etiquette?: string;
  description?: ReactNode;
  actions?: ReactNode;
}

/** En-tête de page : étiquette, titre (h1, focalisé à l'arrivée pour les lecteurs d'écran), actions. */
export function EnTetePage({ titre, etiquette, description, actions }: ProprietesEnTetePage) {
  const ref = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    document.title = `${titre} - Eau Énergie Connect`;
  }, [titre]);
  return (
    <header className={styles.entete}>
      <div className={styles.titres}>
        {etiquette ? <p className="cc-etiquette">{etiquette}</p> : null}
        <h1 ref={ref} tabIndex={-1}>
          {titre}
        </h1>
        {description ? <div className={styles.description}>{description}</div> : null}
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </header>
  );
}
